import LocalCafeIcon from '@mui/icons-material/LocalCafe';
import PaletteIcon from '@mui/icons-material/Palette';
import PetsIcon from '@mui/icons-material/Pets';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import * as React from 'react';

type TCategoriesMenuItem = {
  id: string;
  displayName: string;
  icon: React.ReactNode;
  subCategories: Array<{ id: string; displayName: string }>;
};

/** Phone cases page — filters / related UI (kept for product list constants) */
export const PHONE_CASES_CATEGORIES_MENU_CONFIG: TCategoriesMenuItem = {
  id: 'phone-cases',
  displayName: 'Phone cases',
  icon: <PhoneIphoneIcon color="primary" />,
  subCategories: [
    { id: 'phone-cases-all', displayName: 'All' },
    { id: 'builder', displayName: 'Create your custom case' },
    { id: 'phone-cases-bestsellers', displayName: 'Bestsellers' },
    { id: 'phone-cases-new', displayName: 'New arrivals' },
  ],
};

/** Top-level category + subcategory links for header / navigation mocks */

export const KEYCHAINS_CATEGORIES_MENU_CONFIG: TCategoriesMenuItem = {
  id: 'keychains',
  displayName: 'Keychains',
  icon: <VpnKeyIcon color="primary" />,
  subCategories: [
    { id: 'keychains-all', displayName: 'All' },
    { id: 'keychains-metal', displayName: 'Metal' },
    { id: 'keychains-acrylic', displayName: 'Acrylic' },
    { id: 'keychains-leather', displayName: 'Leather & fabric' },
    { id: 'keychains-engraved', displayName: 'Engraved & personalized' },
    { id: 'keychains-gift', displayName: 'Gift sets' },
  ],
};

export const PETS_CATEGORIES_MENU_CONFIG: TCategoriesMenuItem = {
  id: 'pets',
  displayName: 'Pets',
  icon: <PetsIcon color="primary" />,
  subCategories: [
    { id: 'pets-all', displayName: 'All' },
    { id: 'pets-dogs', displayName: 'Dogs' },
    { id: 'pets-cats', displayName: 'Cats' },
    { id: 'pets-small-animals', displayName: 'Small animals' },
    { id: 'pets-accessories', displayName: 'Bowls & accessories' },
    { id: 'pets-toys', displayName: 'Toys' },
  ],
};

export const PAINTINGS_CATEGORIES_MENU_CONFIG: TCategoriesMenuItem = {
  id: 'paintings',
  displayName: 'Paintings',
  icon: <PaletteIcon color="primary" />,
  subCategories: [
    { id: 'paintings-all', displayName: 'All' },
    { id: 'paintings-canvas', displayName: 'Canvas' },
    { id: 'paintings-posters', displayName: 'Posters' },
    { id: 'paintings-framed', displayName: 'Framed art' },
    { id: 'paintings-abstract', displayName: 'Abstract' },
    { id: 'paintings-landscape', displayName: 'Landscape & nature' },
  ],
};

export const FIDGETS_CATEGORIES_MENU_CONFIG: TCategoriesMenuItem = {
  id: 'fidgets',
  displayName: 'Fidgets',
  icon: <SportsEsportsIcon color="primary" />,
  subCategories: [
    { id: 'fidgets-all', displayName: 'All' },
    { id: 'fidgets-spinners', displayName: 'Spinners' },
    { id: 'fidgets-cubes', displayName: 'Cubes & blocks' },
    { id: 'fidgets-popit', displayName: 'Pop-it & sensory' },
    { id: 'fidgets-stress', displayName: 'Stress balls' },
    { id: 'fidgets-edc', displayName: 'EDC & desk toys' },
  ],
};

export const CUPS_CATEGORIES_MENU_CONFIG: TCategoriesMenuItem = {
  id: 'cups',
  displayName: 'Cups',
  icon: <LocalCafeIcon color="primary" />,
  subCategories: [
    { id: 'cups-all', displayName: 'All' },
    { id: 'cups-mugs', displayName: 'Mugs' },
    { id: 'cups-travel', displayName: 'Travel tumblers' },
    { id: 'cups-thermos', displayName: 'Thermos & bottles' },
    { id: 'cups-personalized', displayName: 'Personalized' },
    { id: 'cups-sets', displayName: 'Sets & gifts' },
  ],
};

/** Full navigation mock: order matches typical shop priority */
export const CATEGORIES_MENU_CONFIG: Array<TCategoriesMenuItem> = [
  PHONE_CASES_CATEGORIES_MENU_CONFIG,
  KEYCHAINS_CATEGORIES_MENU_CONFIG,
  PETS_CATEGORIES_MENU_CONFIG,
  PAINTINGS_CATEGORIES_MENU_CONFIG,
  FIDGETS_CATEGORIES_MENU_CONFIG,
  CUPS_CATEGORIES_MENU_CONFIG,
];
